// extracted by mini-css-extract-plugin
export default {"cls1":"X8QYdg_Kw7_63K5HkWai","cls2":"pCt396o6DVj9yHnoxV_R X8QYdg_Kw7_63K5HkWai"};